import React from 'react';
import PropTypes from 'prop-types';

export const Logo = ({ className = '', size = 'lg', color = 'primary' }) => {
    return (
        <div className={`gift-shop-logo ${className}`}>
            <i
                className={`fad fa-gift text-${color} fa-${size} me-2`}
                // style={{
                //     '--fa-primary-color': 'var(--bs-secondary)',
                //     '--fa-secondary-color': 'var(--bs-primary)',
                //     '--fa-primary-opacity': '1.0',
                //     '--fa-secondary-opacity': '1.0'
                // }}
            />
        </div>
    );
};

Logo.propTypes = {
    className: PropTypes.string,
    size: PropTypes.string,
    color: PropTypes.string
};

// <i className={`fad fa-gift fa-${size} text-${color} me-2`}></i>
